export default "__VITE_ASSET__D_KAZ6EG__"